import Endpoint from "../../services/api/endpoint";
import { IUser } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IUser>(Endpoint.Installers);